import 'components/desktop/Accessory/Search/Components/SearchResultList/SearchResultList.scss';
import ArchiveResultListRow from 'components/desktop/Accessory/Search/Components/SearchResultListRow/ArchiveResultListRow';
import SearchResultListRow from 'components/desktop/Accessory/Search/Components/SearchResultListRow/SearchResultListRow';
import * as Accessory from 'types/Accessory/Search/Accessory';
import * as AccessoryList from 'types/Accessory/Search/AccessoryList';

interface IProps {
	archive: boolean;
	handleArchiveAccessory: (input: string) => Promise<void>;
	handleRestoreAccessory: (input: string) => Promise<void>;
	accessoryList: AccessoryList.Type;
}

const SearchResultList = (props: IProps) => {
	return (
		<div className="row-gy-4">
			<div className="col-lg-12">
				{props.archive ? (
					<>
						{props.accessoryList.map((obj: Accessory.Type, i: number) => {
							return (
								<div key={i}>
									<ArchiveResultListRow
										handleRestoreAccessory={props.handleRestoreAccessory}
										accessory={obj}
									/>
								</div>
							);
						})}
					</>
				) : (
					<>
						{props.accessoryList.map((obj: Accessory.Type, i: number) => {
							return (
								<div key={i}>
									<SearchResultListRow
										handleArchiveAccessory={props.handleArchiveAccessory}
										accessory={obj}
									/>
								</div>
							);
						})}
					</>
				)}
			</div>
		</div>
	);
};

export default SearchResultList;
